<template>
    <b-card
    header-bg-variant="primary"
    header-class="py-2 px-3 text-white"
    body-class="p-3"
    footer-class="py-2 px-3"
    class="mx-0">
    <template #header>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 576 512"><path fill="#fff" d="M312 24v10.5c6.4 1.2 12.6 2.7 18.2 4.2 12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5-7.3-.1-14.7 1.7-19.4 4.4-2.1 1.3-3.1 2.4-3.5 3-.3.5-.7 1.2-.7 2.8v.6c.2.2.9 1.2 3.3 2.6 5.8 3.5 14.4 6.2 27.4 10.1l.9.3c11.1 3.3 25.9 7.8 37.9 15.3 13.7 8.6 26.1 22.9 26.4 44.9.3 22.5-11.4 38.9-26.7 48.5-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24v-11.4c-9.5-2.3-18.2-5.3-25.6-7.8-2.1-.7-4.1-1.4-6-2-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6.9 5 1.7 7.3 2.5 13.6 4.6 23.4 7.9 33.9 8.3 8 .3 15.1-1.6 19.2-4.1 1.9-1.2 2.8-2.2 3.2-2.9.4-.6.9-1.8.8-4.1v-.2c0-1 0-2.1-4-4.6-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4-13.5-8.1-26.5-22-26.6-44.1-.1-22.9 12.9-38.6 27.7-47.4 6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zm256.2 312.3c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.3c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384h-.9.9z"></path></svg>
        Personal Loan
        <a href="javascript:void(0)" @click="$emit('remove-product-application', product_application.pcom_id)" class="position-absolute cursor-pointer" style="right: -14px; top: -7px;" v-if="is_editable">
            <svg xmlns="http://www.w3.org/2000/svg" class="mx-2" width="20" height="20" viewBox="0 0 512 512">
                <circle fill="#DF3030" cx="256" cy="256" r="256" />
                <g fill="#fff" transform="translate(148, 116) scale(0.55)">
                    <path fill="#fff" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256l105.3-105.4z"/>
                </g>
            </svg>
        </a>
    </template>

    <!--Card Body -->
    <div class="my-2">
        <p class="text-xs text-muted">Loan Amt.</p>
        <p class="font-weight-600">RM{{ product_application.pcom_product_detail.pcp_loan_amount | moneyFormatter }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Bank (Interest Rate)</p>
        <p class="font-weight-600">{{ product_application.pcom_bank_code }} ({{ product_application.pcom_product_detail.pcp_interest_rate }}%)</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Monthly Installment</p>
        <p class="font-weight-600">RM{{ product_application.pcom_product_detail.pcp_monthly_installment }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Tenure</p>
        <p class="font-weight-600">{{ product_application.pcom_product_detail.pcp_tenure }} Years</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">AF Amount (AF%)</p>
        <p class="font-weight-600">RM{{ product_application.pcom_product_detail.pcp_arragement_fee_amount | moneyFormatter }}</p>
    </div>
</b-card>
</template>
<script>

export default {
    props:['product_application', 'is_editable']
}
</script>